<span
  class="badge"
  [innerHTML]="getInfo()"
  *ngIf="!ignoreEnvironments.includes(environment.ENV?.toLowerCase())"
></span>
